// extracted by mini-css-extract-plugin
module.exports = {"content_title":"content_title-2i5cY33_"};